import axios from "axios";

export class S3Service {
    static async getPreSignedUrl(contentType) {
        const headers = {
            "x-access-token": process.env.REACT_APP_S3_BUCKET_APP_TOKEN
        };
        const res = await axios.post(
            `${process.env.REACT_APP_S3_BUCKET_URL}files`,
            {
                contentType
            },
            {headers}
        );
        return res.data;
    }

    static async uploadFileToS3(url, data) {
        const res = await axios.post(url, data);
        return res;
    }

    static async uploadToS3(
        fileType,
        fileName,
        fileContents,
        folder_name = "other"
    ) {
        try {
            const body = {
                contentType: fileType,
            };

            const config = {
                headers: {
                    "x-access-token": process.env.REACT_APP_S3_BUCKET_APP_TOKEN,
                    "Access-Control-Allow-Origin": "*",
                },
            };

            const presignedPostUrlResponse = await fetch(
                `${process.env.REACT_APP_S3_BUCKET_URL}files`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        ...config.headers,
                    },
                    body: JSON.stringify(body),
                }
            );


            if (!presignedPostUrlResponse.ok) {
                throw new Error("Failed to get presigned URL");
            }

            const presignedPostUrl = await presignedPostUrlResponse.json();
            let key;
            let url;
            if (presignedPostUrl?.data?.result?.fields?.Key) {
                key = presignedPostUrl?.data?.result?.fields?.Key;
            }
            if (presignedPostUrl?.data?.url) {
                url = presignedPostUrl?.data?.url;
            }

            const formData = new FormData();
            Object.entries(presignedPostUrl?.data?.result?.fields).forEach(([k, v]) => {
                formData.append(k, v);
            });
            formData.append("file", fileContents);
            const response = await fetch(presignedPostUrl?.data?.result?.url, {
                method: "POST",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                },
                body: formData,
            });

            if (response.status == 200 || response.status == 204) {
                return url;
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }


        // static async getEzPlans(params) {
        //   const filteredParams = getFilteredParams(params);
        //   const res = await api.get("ezplan", {
        //     params: filteredParams
        //   });
        //   return res.data;
        // }
    }
}
